var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22925 30.6209C9.10523 29.9952 10.2295 29.8311 11.2478 30.1802L34.5811 38.1802C35.9284 38.6421 36.8334 39.9091 36.8334 41.3334V50C36.8334 51.3335 36.0387 52.5386 34.8131 53.0638L11.4798 63.0638C10.4499 63.5052 9.26716 63.3996 8.33174 62.7828C7.39632 62.166 6.83337 61.1205 6.83337 60V33.3334C6.83337 32.2569 7.35326 31.2466 8.22925 30.6209ZM13.5 38V54.9449L30.1667 47.802V43.7143L13.5 38Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1126 6.8378C39.7968 6.60973 40.5366 6.60973 41.2208 6.8378L71.2208 16.8378C72.5819 17.2915 73.5 18.5653 73.5 20.0001C73.5 21.4348 72.5819 22.7086 71.2208 23.1624L41.2208 33.1624C40.5366 33.3904 39.7968 33.3904 39.1126 33.1624L9.11261 23.1624C7.75147 22.7086 6.83337 21.4348 6.83337 20.0001C6.83337 18.5653 7.75147 17.2915 9.11261 16.8378L39.1126 6.8378ZM20.7076 20.0001L40.1667 26.4864L59.6258 20.0001L40.1667 13.5137L20.7076 20.0001Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1215 30.6334C72.9873 31.2603 73.5 32.2644 73.5 33.3334V60C73.5 61.3335 72.7053 62.5386 71.4797 63.0638L48.1464 73.0638C47.1165 73.5052 45.9338 73.3996 44.9984 72.7828C44.0629 72.166 43.5 71.1205 43.5 70V41C43.5 39.56 44.4247 38.2828 45.7928 37.8333L69.1262 30.1666C70.1417 29.8329 71.2557 30.0065 72.1215 30.6334ZM50.1667 43.4134V64.9449L66.8333 57.802V37.9373L50.1667 43.4134Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.2b9aef700702e2a00b7d6f352975085d.svg";
export { ForwardRef as ReactComponent };